var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"dl export-button",attrs:{"small":"","outlined":"","elevation":"0"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"export-icon",attrs:{"size":"14"}},[_vm._v("mdi-tray-arrow-up")]),_vm._v(" 업로드 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }